module.exports = __webpack_public_path__ + "static/media/2 3 Ordkjedetest-Feil-los-tupp-meg-sa.b9637b79.wav";